import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { useFormikContext } from "formik";
import useCurrency from "helpers/useCurrency";
import RecalculateIcon from "assets/icons/RecalculateIcon";
import { useEffect } from "react";
import BasicSelect from "components/BasicInputs/BasicSelect";
import { useDispatch, useSelector } from "react-redux";
import { apiGetAccountingTypes } from "api/accountingTypeApi";
import PercentIcon from "assets/icons/PercentIcon";
import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";

function calculateFee(tablePrice: number, feeValue?: number, type?: "price" | "percent") {
  if (!type || !feeValue) return 0;
  if (type === "price") {
    return feeValue;
  } else {
    return tablePrice * (feeValue / 100);
  }
}

const dataKey: {
  [key: string]: "costs" | "wages";
} = {
  cost: "costs",
  wage: "wages",
};

const Fee: React.FC<OrderFee> = (props) => {
  const { defCur } = useCurrency();
  const { values, setFieldValue } = useFormikContext<MaterialOrderData>();
  const store = useSelector((state: any) => state);
  const costTypes = store.accountingReducer?.accountingTypes?.cost || {};
  const dispatch: any = useDispatch();
  const token = store.businessReducer.business.token;

  useEffect(() => {
    const newRows = [...(values[dataKey[props.label]] || [])];
    const index = newRows.findIndex((x) => x.ind === props.ind);
    if (index > -1) {
      newRows[index] = {
        ...props,
        amount: calculateFee(values.tableTotalPrice, props.value, props.type),
      };
      setFieldValue(dataKey[props.label], newRows);
    }
  }, [props.value, props.type, values.tableTotalPrice, values.formulaId]);

  return (
    <div className="flex items-center gap-3">
      <div className="w-[300px]">
        <BasicSelect
          label="انتخاب حساب"
          options={{
            title: costTypes.title,
            id: "main",
            childs: costTypes.childs.map((x: any) => ({
              ...x,
              parentId: "main",
            })),
          }}
          defaultValue={props.accountTypeId}
          isNested
          withSearch
          withRefresh
          menuStyle={{ minWidth: "300px !important" }}
          refreshList={() => dispatch(apiGetAccountingTypes(token, "cost"))}
          onChange={(v) => {
            const newRows = [...(values[dataKey[props.label]] || [])];
            const index = newRows.findIndex((x) => x.ind === props.ind);
            if (index > -1) {
              newRows[index] = {
                ...props,
                accountTypeId: v,
              };
              setFieldValue(dataKey[props.label], newRows);
            }
          }}
        />
      </div>
      <div className="flex gap-3">
        <div className="w-44">
          <BasicTextInput
            type="price"
            label={props.label === "cost" ? "سربار تولید" : "هزینه دستمزد"}
            style={{ padding: "0px 12px 0px 0px" }}
            prefix={
              <div
                className="px-4 border-r cursor-pointer border-slate-300 text-[#1062d0]"
                onClick={() => {
                  const newRows = [...(values[dataKey[props.label]] || [])];
                  const index = newRows.findIndex((x) => x.ind === props.ind);
                  if (index > -1) {
                    newRows[index] = {
                      ...props,
                      type: props.type === "price" ? "percent" : "price",
                    };
                    setFieldValue(dataKey[props.label], newRows);
                  }
                }}
              >
                {props.type === "price" ? (
                  <div>{defCur.en_title}</div>
                ) : (
                  <PercentIcon style={{ transform: "scale(0.7)" }} />
                )}
              </div>
            }
            onChange={(v) => {
              const newRows = [...(values[dataKey[props.label]] || [])];
              const index = newRows.findIndex((x) => x.ind === props.ind);
              if (index > -1) {
                newRows[index] = {
                  ...props,
                  value: +v,
                };
                setFieldValue(dataKey[props.label], newRows);
              }
            }}
            val={props.value}
          />
        </div>
        {/* <div
          className="flex self-end gap-2 py-2 cursor-pointer h-fit"
          onClick={() => {
            const newRows = [...(values[dataKey[props.label]] || [])];
            const index = newRows.findIndex((x) => x.ind === props.ind);
            if (index > -1) {
              newRows[index] = {
                ...props,
                amount: calculateFee(values.tableTotalPrice, props.value, props.type),
              };
              setFieldValue(dataKey[props.label], newRows);
            }
          }}
        >
          <RecalculateIcon />
          <span className="text-[#1062D0] font-medium">محاسبه مجدد</span>
        </div> */}
      </div>
      <IconButton
        aria-label="delete"
        className="h-8 mr-2 mt-7"
        onClick={() => {
          const newRows = values[dataKey[props.label]].filter((x: any) => x.ind !== props.ind);
          setFieldValue(dataKey[props.label], newRows);
        }}
      >
        <Close className="text-base" />
      </IconButton>
    </div>
  );
};

export default Fee;
